import type { ISocialOffer } from "@bbj-types/offer";
import BusinessIcon from "@mui/icons-material/BusinessOutlined";
import LinkIcon from "@mui/icons-material/LinkOutlined";
import MailIcon from "@mui/icons-material/MailOutlined";
import PersonIcon from "@mui/icons-material/PersonOutlined";
import PhoneIcon from "@mui/icons-material/PhoneOutlined";
import PlaceIcon from "@mui/icons-material/PlaceOutlined";
import WorkIcon from "@mui/icons-material/Work";
import { Stack, Typography } from "@mui/material";
import { formatPhoneNumber } from "@root/utils/phoneLib";
import { IconInfo } from "@styleguide";
import { InfoCard, infoCardClasses } from "../styles";

interface ISocialOfferUsefulInformationsProps {
  offer: ISocialOffer;
}

export const SocialOfferUsefulInformations = ({ offer }: ISocialOfferUsefulInformationsProps) => {
  return (
    <Stack sx={{ width: "100%", px: 3 }}>
      <InfoCard className={infoCardClasses.root}>
        <Typography variant="subtitle2SemiBold">Informations utiles</Typography>
        <IconInfo Icon={BusinessIcon} text={offer.provider?.name} hidden={!offer.provider?.name} noWrap />
        <IconInfo Icon={PlaceIcon} text={offer.address?.formatted} hidden={!offer.address?.formatted} />
        <IconInfo Icon={PlaceIcon} text={"Offre disponible à distance"} hidden={!offer.isRemote} />
        <IconInfo
          Icon={LinkIcon}
          tooltip={offer.provider?.website}
          text={
            <a target="_blank" rel="noopener noreferrer" href={offer.provider?.website}>
              {offer.provider?.website}
            </a>
          }
          hidden={!offer.provider?.website}
          noWrap
        />
        <IconInfo Icon={WorkIcon} text={offer.contact?.comment} hidden={!offer.contact?.comment} noWrap />
        <IconInfo Icon={PersonIcon} text={offer.contact?.name} hidden={!offer.contact?.name} noWrap />
        <IconInfo
          Icon={PhoneIcon}
          text={formatPhoneNumber(offer.contact?.phone)}
          hidden={!offer.contact?.phone}
          noWrap
        />
        <IconInfo Icon={MailIcon} text={offer.contact?.mail} hidden={!offer.contact?.mail} noWrap />
      </InfoCard>
    </Stack>
  );
};
